import React, { useEffect, useState } from "react";

export default function SideMenu({ history }) {
  const [usernome, setUsernome] = useState("");
  const [online, setOnline] = useState(true);
  const [useradm, setUseradm] = useState(false);
  const [isMaster, setIsMaster] = useState(false);
  const userid = localStorage.getItem("sgiuserid");

  useEffect(() => {
    if (userid === null) window.location.href = "/login";
    else setUsernome(localStorage.getItem("sgiusernome"));

    if (localStorage.getItem("sgiadmin") === "true") {
      setUseradm(true);
    }

    if (localStorage.getItem("sgimaster") === "true") {
      setIsMaster(true);
    }
  }, []);

  return (
    <>
      <aside className="main-sidebar">
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img src="/dist/img/user.png" className="img-circle" alt="User" style={{width: '45px', height: '45px', objectFit: 'cover'}} />
            </div>
            <div className="pull-left info">
              <p>{usernome}</p>

              {online && (
                <a id="status_estab" info="online">
                  <i className="fa fa-circle text-success" /> Online
                </a>
              )}

              {!online && (
                <a id="status_estab" info="offline">
                  <i className="fa fa-circle text-danger" /> Offline
                </a>
              )}

              {/* {!online &&
                <a style={{cursor:'pointer'}} onClick={() => atualizaStatus(true)}>
                  <span className="text-success">(ficar online)</span>
                </a>
              }

              {online &&
              <a style={{cursor:'pointer'}} onClick={() => atualizaStatus(false)}>
                <span className="text-danger">(ficar offline)</span>
              </a>
              } */}
            </div>
          </div>

          <ul className="sidebar-menu" data-widget="tree">
            <li className="header">MENU PRINCIPAL</li>
            <li id="menu_admin" className="treeview active">
              <ul className="treeview-menu">
              <li id="menu_painel_integracao">
                  <a href="/painel?integracao=1">
                    <i className="fa fa-puzzle-piece" />{" "}
                    <span>Minha Integração</span>
                  </a>
                </li>
                <li id="menu_painel">
                  <a href="/painel">
                    <i className="fa fa-graduation-cap" />{" "}
                    <span>Meus Treinamentos</span>
                  </a>
                </li>
                {useradm && (
                  <li id="menu_acompanhamento">
                    <a href="/acompanhamento">
                      <i className="fa fa-line-chart" />{" "}
                      <span>Acompanhamento</span>
                    </a>
                  </li>
                )}
              </ul>
            </li>

            {/* <li id="menu_chamado" className="treeview active">
              <a href="#">
                <i className="fa fa-ticket"></i>
                <span>Meus Treinamentos</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu">
                <li id="menu_chamado_consulta"><a href="/chamados"><i className="fa fa-circle-o"></i> Consultar</a></li>
              </ul>
            </li> */}

            {/* <li id="menu_contrato" className="treeview active">
              <a href="#">
                <i className="fa fa-file"></i>
                <span>Contratos</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu">           
              {useradm &&
                <li id="menu_contrato_novo"><a href="/contrato/novo"><i className="fa fa-circle-o"></i> Criar Novo</a></li>
              }
                <li id="menu_contrato_consulta"><a href="/contratos"><i className="fa fa-circle-o"></i> Consultar</a></li>
              </ul>
            </li> */}

            {/* <li class="treeview">
              <a href="#">
                <i class="fa fa-pie-chart"></i>
                <span>Relatórios</span>
                <span class="pull-right-container">
                  <i class="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul class="treeview-menu">
                <li><a href="#"><i class="fa fa-circle-o"></i> Checklists Pendentes</a></li>
                <li><a href="#"><i class="fa fa-circle-o"></i> Checklists Finalizados</a></li>
                <li><a href="#"><i class="fa fa-circle-o"></i> Checklists em Andamento</a></li>
                <li><a href="#"><i class="fa fa-circle-o"></i> Customizar</a></li>
              </ul>
            </li> */}
<br></br>
            {useradm && (
              <>
                <li className="header">ADMINISTRACAO</li>
                <li id="menu_admin" className="treeview active">
                  <ul className="treeview-menu">
                    <li id="menu_produto">
                      <a href="/produtos">
                        <i className="fa fa-book"></i> Cadastro Treinamentos
                      </a>
                    </li>
                    <li id="menu_integracao">
                      <a href="/integracoes">
                        <i className="fa fa-plug"></i> Cadastro Integração
                      </a>
                    </li>
                    <li id="menu_usuario">
                      <a href="/usuarios">
                        <i className="fa fa-users"></i> Cadastro Usuários
                      </a>
                    </li>
                    {isMaster && (
                      <>
                        <li id="menu_cliente">
                          <a href="/clientes">
                            <i className="fa fa-building"></i> Cadastro Clientes
                          </a>
                        </li>
                        <li id="menu_pedido">
                          <a href="/pedidos">
                            <i className="fa fa-shopping-cart"></i> Pedidos
                          </a>
                        </li>
                      </>
                    )}
                  </ul>
                </li>
              </>
            )}
          </ul>
        </section>
      </aside>
    </>
  );
}
